// Simplified image imports
export interface ImageAssets {
  hero: string;
  benefits: string;
}

const heroImage = 'https://images.unsplash.com/photo-1580273916550-e323be2ae537?auto=format&fit=crop&q=80';
const benefitsImage = 'https://images.unsplash.com/photo-1560179707-f14e90ef3623?auto=format&fit=crop&q=80';

export const images: ImageAssets = {
  hero: heroImage,
  benefits: benefitsImage
};